import { Page } from '@app/routes';

export const FOOTER_HEIGHT = 68;

export const DAILY_ENERGY_ROUTES = [Page.DAILY_ENERGY, Page.DAILY_ENERGY_DESCRIPTION];

export const HIDDEN_HEADER_ROUTES = [Page.AUTH, Page.USER_DATA_FORM, Page.INSTRUCTIONS];

export const HIDDEN_FOOTER_ROUTES = [
  Page.AUTH,
  Page.USER_DATA_FORM,
  Page.INSTRUCTIONS,
  Page.DAILY_ENERGY,
  Page.SETTLEMENT_DETAILS,
];

export const HIDDEN_USER_AGREEMENT_MODAL_ROUTES = [Page.AUTH, Page.INSTRUCTIONS];

export const NO_PADDING_ROUTES = [
  Page.USER_DATA_FORM,
  Page.INSTRUCTIONS,
  Page.HOME,
  Page.DAILY_ENERGY,
  Page.FRIENDS,
  Page.SHOP,
  Page.BALANCE_HISTORY,
  Page.SETTLEMENT_DETAILS,
  Page.DAILY_CARD_PREVIEW,
];

export const HEADER_COOKIE_BALANCE_ID = 'header-cookie-balance';
